<template>
  <div>Logout</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      services: "design/page/services",
    }),
  },
  beforeCreate() {
    localStorage.removeItem('apiToken');
    localStorage.removeItem('refreshToken');
    window.location.href = this.services.webbuilder + '/logout.php';
  },
};
</script>

<style>
</style>